/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AgentCrashBuild,
  AgentCrashBuild$Outbound,
  AgentCrashBuild$outboundSchema,
} from "./agentcrashbuild.js";
import {
  AgentCrashFrame,
  AgentCrashFrame$Outbound,
  AgentCrashFrame$outboundSchema,
} from "./agentcrashframe.js";
import {
  AgentCrashRollback,
  AgentCrashRollback$Outbound,
  AgentCrashRollback$outboundSchema,
} from "./agentcrashrollback.js";

/**
 * One device agent crash: a fatal crash, a recovered panic, or a self-rollback.
 */
export type AgentCrashReport = {
  build: AgentCrashBuild;
  /**
   * Where it happened: ipc, policy_scheduler, update_scheduler, aiscan, sessions, ui or runtime.
   */
  component: string;
  /**
   * Times this crash recurred in one process before it was reported.
   */
  count: number;
  /**
   * Random report id; repeats of the same id are one report.
   */
  id: string;
  /**
   * fatal, recovered or rollback.
   */
  kind: string;
  /**
   * Go runtime error text, when the panic was one. Other panics send panic_type instead.
   */
  message?: string | undefined;
  /**
   * When it happened, by the device clock.
   */
  occurredAt: Date;
  /**
   * Goroutines in a fatal dump besides the crashing one. Their stacks are not sent.
   */
  otherGoroutines?: number | undefined;
  /**
   * Go type of a non-runtime panic value.
   */
  panicType?: string | undefined;
  rollback?: AgentCrashRollback | undefined;
  /**
   * Report schema version.
   */
  schemaVersion: number;
  /**
   * Frames of the crashing goroutine, innermost first.
   */
  stack?: Array<AgentCrashFrame> | undefined;
};

/** @internal */
export type AgentCrashReport$Outbound = {
  build: AgentCrashBuild$Outbound;
  component: string;
  count: number;
  id: string;
  kind: string;
  message?: string | undefined;
  occurred_at: string;
  other_goroutines?: number | undefined;
  panic_type?: string | undefined;
  rollback?: AgentCrashRollback$Outbound | undefined;
  schema_version: number;
  stack?: Array<AgentCrashFrame$Outbound> | undefined;
};

/** @internal */
export const AgentCrashReport$outboundSchema: z.ZodMiniType<
  AgentCrashReport$Outbound,
  AgentCrashReport
> = z.pipe(
  z.object({
    build: AgentCrashBuild$outboundSchema,
    component: z.string(),
    count: z.int(),
    id: z.string(),
    kind: z.string(),
    message: z.optional(z.string()),
    occurredAt: z.pipe(z.date(), z.transform(v => v.toISOString())),
    otherGoroutines: z.optional(z.int()),
    panicType: z.optional(z.string()),
    rollback: z.optional(AgentCrashRollback$outboundSchema),
    schemaVersion: z.int(),
    stack: z.optional(z.array(AgentCrashFrame$outboundSchema)),
  }),
  z.transform((v) => {
    return remap$(v, {
      occurredAt: "occurred_at",
      otherGoroutines: "other_goroutines",
      panicType: "panic_type",
      schemaVersion: "schema_version",
    });
  }),
);

export function agentCrashReportToJSON(
  agentCrashReport: AgentCrashReport,
): string {
  return JSON.stringify(
    AgentCrashReport$outboundSchema.parse(agentCrashReport),
  );
}
